export type TelegramWebApp = NonNullable<NonNullable<Window['Telegram']>['WebApp']>;

export function getTelegramWebApp(): TelegramWebApp | undefined {
  return window.Telegram?.WebApp;
}

export function isTelegramMiniApp(): boolean {
  return Boolean(getTelegramWebApp()?.initData);
}

export function getTelegramInitData(): string {
  return getTelegramWebApp()?.initData ?? '';
}

export function canRequestTelegramContact(): boolean {
  return typeof getTelegramWebApp()?.requestContact === 'function';
}

export function requestTelegramContact(): Promise<boolean> {
  const wa = getTelegramWebApp();
  const requestContact = wa?.requestContact;
  if (!wa || typeof requestContact !== 'function') return Promise.resolve(false);
  return new Promise((resolve) => {
    let settled = false;
    const onRequested = (payload?: { status?: string }) => {
      done(payload?.status !== 'cancelled');
    };
    const done = (ok: boolean) => {
      if (settled) return;
      settled = true;
      wa.offEvent?.('contactRequested', onRequested);
      resolve(ok);
    };
    wa.onEvent?.('contactRequested', onRequested);
    requestContact((shared) => done(!!shared));
  });
}

export function openTelegramBot(username: string, start = 'auth') {
  const url = `https://t.me/${username}${start ? `?start=${encodeURIComponent(start)}` : ''}`;
  const wa = getTelegramWebApp();
  if (typeof wa?.openTelegramLink === 'function') {
    wa.openTelegramLink(url);
    return;
  }
  window.open(url, '_blank');
}

function inset(n: number | undefined): string {
  return `${Math.max(0, n ?? 0)}px`;
}

export function applyTelegramChrome(): void {
  const wa = getTelegramWebApp();
  if (!wa) return;

  wa.ready();
  wa.expand();
  try {
    wa.setHeaderColor('#0a0a0a');
    wa.setBackgroundColor('#0a0a0a');
  } catch {
    /* old clients */
  }

  const safe = wa.safeAreaInset;
  const content = wa.contentSafeAreaInset;
  const root = document.documentElement;
  root.style.setProperty('--tg-safe-area-inset-top', inset((safe?.top ?? 0) + (content?.top ?? 0)));
  root.style.setProperty('--tg-safe-area-inset-bottom', inset((safe?.bottom ?? 0) + (content?.bottom ?? 0)));
  root.style.setProperty('--tg-safe-area-inset-left', inset(safe?.left));
  root.style.setProperty('--tg-safe-area-inset-right', inset(safe?.right));
  root.classList.add('tg-miniapp');
}
